import { IQuery } from 'core-ts-types';
import { IDatasource, Query } from 'utility-ts-orm';
import { PathTopic } from './../builders/path_topic_builder';

export class CurrentTopicsQuery implements IQuery {
  private _result: PathTopic[];
  private _count: number;

  constructor(private ngPathCurrentTopicDatastore: IDatasource<PathTopic>) {
    Query.registerQuery(this, this.ngPathCurrentTopicDatastore);
  }

  run(): this {
    this._result = _.sortBy(
      this.ngPathCurrentTopicDatastore.query((topic: PathTopic) => !!topic.id),
      'rank'
    );
    this._count = this._result.length;
    return this;
  }

  get result() {
    return this._result;
  }

  get count() {
    return this._count;
  }
}

angular.module('data-ng-todos').service('ngCurrentTopicsQuery', CurrentTopicsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/queries/current_topics_query.ts